export default __webpack_public_path__ + "static/timberline-electric-lab-small-c5c97e6cabf0a31e43b3136e321eb015.jpg";